import { jsx, jsxs } from "react/jsx-runtime";
import { Modal, Banner, CheckboxInput, ModalButtonRow, Button } from "@flatfile/design-system";
import useFindAndReplaceData from "../../../hooks/useFindAndReplaceProps.js";
import ModalSpinner from "../ModalSpinner.js";
import { ErrorContainer, FilteredContainer, ModalText, CheckboxContainer } from "../Styles.js";
import { NullContentHeader, FindValueModalContent, ReplaceValueContent } from "./FindAndReplaceModalContent.js";
import { useTranslation } from "react-i18next";
const MODAL_ID = "findAndReplaceModal";
const FindAndReplaceModalContent = (props) => {
  const { t } = useTranslation();
  const {
    closeModal,
    columnConfig,
    columnIndex,
    getFindAndReplaceModalProps,
    onSubmit,
    replaceNulls,
    isFiltered
  } = props;
  const {
    columnName,
    count,
    handleBooleanChange,
    handleChange,
    handleOnSearch,
    toggleExactMatchOnly,
    handleOnSubmit,
    isFetchingProps,
    isSubmitting,
    replaceValue,
    type,
    options,
    errorText,
    setDisableSubmit,
    disableSubmit,
    exactMatchesOnly,
    toggleIgnoreFilter,
    ignoreFilter
  } = useFindAndReplaceData({
    closeModal,
    columnConfig,
    columnIndex,
    getFindAndReplaceModalProps,
    onSubmit
  });
  const noResults = count === 0;
  const showReplaceOptions = !(noResults && replaceNulls);
  const loadingText = isFetchingProps ? t("sheet.table.contextMenu.findAndReplace.modal.finding") : t("sheet.table.contextMenu.findAndReplace.modal.replacing");
  return /* @__PURE__ */ jsxs("form", { onSubmit: handleOnSubmit, id: MODAL_ID, children: [
    replaceNulls ? /* @__PURE__ */ jsx(
      NullContentHeader,
      {
        columnName,
        count,
        handleOnSearch,
        ignoreFilter
      }
    ) : /* @__PURE__ */ jsx(
      FindValueModalContent,
      {
        columnName,
        columnType: type,
        count,
        handleOnSearch,
        setDisableSubmit,
        toggleExactMatchOnly,
        exactMatchesOnly,
        ignoreFilter
      }
    ),
    /* @__PURE__ */ jsx(
      ReplaceValueContent,
      {
        handleBooleanChange,
        handleChange,
        noResults,
        options,
        replaceNulls,
        replaceValue,
        showReplaceOptions,
        type
      }
    ),
    errorText ? /* @__PURE__ */ jsx(ErrorContainer, { children: /* @__PURE__ */ jsx(Banner, { variant: "error", title: "", message: errorText }) }) : null,
    isFiltered && /* @__PURE__ */ jsxs(FilteredContainer, { children: [
      /* @__PURE__ */ jsx(ModalText, { children: t("sheet.table.contextMenu.findAndReplace.modal.isFiltered") }),
      /* @__PURE__ */ jsx(CheckboxContainer, { children: /* @__PURE__ */ jsx(
        CheckboxInput,
        {
          id: "run-on-all-records",
          checked: ignoreFilter,
          onChange: toggleIgnoreFilter,
          label: t(
            "sheet.table.contextMenu.findAndReplace.modal.runOnAllRecords"
          ),
          smallLabel: true
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs(ModalButtonRow, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: noResults && replaceNulls ? "primary" : "tertiary-border",
          onPress: closeModal,
          isDisabled: isSubmitting,
          label: t("sheet.table.contextMenu.findAndReplace.modal.cancelButton")
        }
      ),
      isFetchingProps || isSubmitting ? /* @__PURE__ */ jsx(ModalSpinner, { text: loadingText }) : showReplaceOptions && /* @__PURE__ */ jsx(
        Button,
        {
          type: "submit",
          isDisabled: replaceNulls && replaceValue === "" || noResults || disableSubmit,
          label: t(
            "sheet.table.contextMenu.findAndReplace.modal.replaceButton"
          )
        }
      )
    ] })
  ] });
};
const FindAndReplaceModal = (props) => {
  const content = FindAndReplaceModalContent(props);
  return /* @__PURE__ */ jsx(Modal, { content });
};
export {
  MODAL_ID,
  FindAndReplaceModal as default
};
